import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'wait',
  version: '1.0.0',
  properties: [
    {
      key: 'unit',
      label: 'Unit',
      type: 'options',
      required: true,
      default: 'seconds',
      options: [
        { value: 'milliseconds', name: 'Milliseconds' },
        { value: 'seconds', name: 'Seconds' },
        { value: 'minutes', name: 'Minutes' },
        { value: 'hours', name: 'Hours' },
      ],
    },
    {
      key: 'amount',
      label: 'Amount',
      type: 'number',
      required: true,
      default: 1,
      typeOptions: {
        minValue: 0,
      },
    },
  ],
};

export default schema;
